import React from 'react'
import {useSelector} from 'react-redux'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {Brand} from '@vio/core/src/brand/types'
import {getLocalizedHelpUrl} from '@vio/core/src/brand/utils'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {getLanguageCode} from '@vio/core/src/localization/services/locale'

import {StyledListItem} from '../commonStyles'

interface Props {
  brand: Brand
}

export const GetHelpLink = ({brand}: Props) => {
  const languageCode = useSelector(getLanguageCode)

  return (
    <StyledListItem
      as="link"
      hasDivider
      href={getLocalizedHelpUrl(brand, languageCode)}
      target="_blank"
      rel="noopener noreferrer"
      prefix={<Icon name="Help" />}
      title={
        <Text variant="labelM">
          <FormattedMessageWrapper id="getHelp" defaultMessage="Get help" />
        </Text>
      }
      suffix={<Icon name="Share" hasMirror />}
    />
  )
}
